import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

const TotalVolumeDescription = styled.p`
    margin: 0;
    ${setFontVariant("dataTable2")};
    color: ${colorsPalettes.carbon[300]};
`;

export const SearchVolumeOverTimeTotalVolumeDescription = () => {
    const translate = useTranslation();

    return (
        <TotalVolumeDescription>
            {translate("demand.analysis.search.trends.overview.change.volume.total")}
        </TotalVolumeDescription>
    );
};
